export default "__VITE_ASSET__ac6f6963__"